angular.module('unergie.main')
.controller('warningsCtrl', ($scope, $state, DataAccessSearch, NgTableParams, ReferencesService, ErrorCatcher) => {
    const refresh = function () {
        $scope.refreshing = true
        return DataAccessSearch({ orderBy: '-modification_ts', limit: 1000 })
        .search({ resource: 'warning' }).$promise.then((data) => {
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 25,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data })
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.refresh = refresh
    refresh()

    $scope.isActive = (state) => $state.is(state)

    return ReferencesService.getRef('warningsTypes').then((mapping) => {
        $scope.warningsTypes = mapping
    })
})
